// extracted by mini-css-extract-plugin
export default {"root":"flags_root__VKx2n","ru":"flags_ru__95-Cy","kg":"flags_kg__9maqi","kk":"flags_kk__bqi44","placeHolderShimmer":"flags_placeHolderShimmer__QnELt"};